<h4 class="content-block ap-green">Technology and Equipment List</h4>

<div id="form-container">
  <dx-form id="form" [colCount]="10" [showColonAfterLabel]="true">
      <dxi-item [colSpan]="2">
          <dxo-label text="Plant" style="font-weight: bold;"></dxo-label>
          <dx-select-box [dataSource]="sitesDataSource" placeholder="Choose Plant" [showClearButton]="true" [searchEnabled]="true"
                         (onValueChanged)="onSiteValueChanged($event)" [(value)]="selectedSite"
                         displayExpr="plantName" valueExpr="siteId"></dx-select-box>
      </dxi-item>      
  </dx-form>
</div>

<dx-data-grid id="gridContainer"
            [dataSource]="filteredEquipments"
            class="fixGridHeight"
            keyExpr="equipmentId"
            [allowColumnReordering]="true"
            [showRowLines]="true"
            [showColumnLines]="true"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [rowAlternationEnabled]="true"
            [columnHidingEnabled]="false"
            [allowColumnResizing]="true"
            (onRowDblClick)="onRowDoubleClick($event)"
            (onRowUpdating)="onSaving($event)">

  <dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
  <dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
  <dxo-filter-panel [visible]="false"></dxo-filter-panel>
  <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
  <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
  <dxo-pager
    [visible]="true"
    [allowedPageSizes]="allowedPageSizes"
    [showPageSizeSelector]="true"
    [showInfo]="true"
    [showNavigationButtons]="false"
  >
  </dxo-pager>
  <dxo-toolbar>
    <dxi-item name="groupPanel"></dxi-item>
    <dxi-item location="after">
        <dx-button text="Reset" type="default" (onClick)="resetFilters()">
      </dx-button>
      <dx-button icon="exportxlsx" type="default" text="Export to Excel" (onClick)="exportExcel($event)">
      </dx-button>
    </dxi-item>
    <dxi-item name="searchPanel"></dxi-item>
  </dxo-toolbar>
  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
  <dxi-column dataField="equipmentId" dataType="string" [allowEditing]="false" [fixed]="true" cellTemplate="equipementLinkCellTemplate" caption="Equipment ID" [width]="125" headerCellTemplate="boldHeaderTemplate"></dxi-column>
  <div *dxTemplate="let cell of 'equipementLinkCellTemplate'"><a href="/update-equipment/{{cell.data.equipmentId}}/{{cell.data.productionFacilityId}}">{{cell.text}}</a></div>
  <dxi-column dataField="plantShortDesc" caption="Plant" [width]="225" [fixed]="true" headerCellTemplate="titleHeaderTemplate">
  </dxi-column>
  <div *dxTemplate="let info of 'titleHeaderTemplate'">
    <b>{{info.column.caption}}</b>
  </div>
  <dxi-column dataField="productionFacilityId" dataType="string" caption="Production Facility ID" [width]="125" headerCellTemplate="boldHeaderTemplate">
  </dxi-column>
  <dxi-column dataField="equipmentType" caption="Equipment Type" [width]="240" headerCellTemplate="boldHeaderTemplate"></dxi-column>
  <div *dxTemplate="let info of 'boldHeaderTemplate'">
    <b>{{info.column.caption}}</b>
  </div>
  <dxi-column dataField="equipmentProvider" headerCellTemplate="boldHeaderTemplate" [width]="125" caption="Equipment Provider"></dxi-column>
  <dxi-column dataField="technologyProvider" caption="Technology Provider" [width]="145" headerCellTemplate="boldHeaderTemplate"></dxi-column>
  <dxi-column dataField="engineeringProvider" caption="Engineering Provider" [width]="145" headerCellTemplate="boldHeaderTemplate"></dxi-column> 
  <dxi-column dataField="industrialGasProvider" caption="Industrial Gas Provider" [width]="145" headerCellTemplate="boldHeaderTemplate"></dxi-column> 
  <dxi-column dataField="awardMonth" dataType="string" caption="Award Month" [width]="100" headerCellTemplate="boldHeaderTemplate"></dxi-column> 
  <dxi-column dataField="awardYear" dataType="string" caption="Award Year" [width]="100" headerCellTemplate="boldHeaderTemplate"></dxi-column> 
  <dxi-column dataField="awardStatus" caption="Award Status" [width]="100" headerCellTemplate="boldHeaderTemplate"></dxi-column> 
  <dxi-column dataField="lastContactedBy" caption="Last Contacted By" [width]="125" headerCellTemplate="boldHeaderTemplate"></dxi-column> 
  <dxi-column dataField="lastContactedDate" cellTemplate="contactedDateCellTemplate" [setCellValue]="setStateValue" caption="Last Contacted Date" [width]="145" headerCellTemplate="boldHeaderTemplate"></dxi-column> 
  <div *dxTemplate="let cell of 'contactedDateCellTemplate'">{{setDateCellValue(cell.text)}}</div>
</dx-data-grid>

<dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false"></dx-load-panel>